const cards = [
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
];
export default cards;
